import Stack from '@/design_system/Stack';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ArticleDistributorWarrantyExtension } from './ArticleDistributorWarrantyExtension';
import { ArticleOrderNumber } from './ArticleOrderNumber';
import { ArticleProofOfPurchase } from './ArticleProofOfPurchase';
import { ArticlePurchaseChannel } from './ArticlePurchaseChannel';
import { ArticlePurchaseCountry } from './ArticlePurchaseCountry';
import { ArticlePurchaseDate } from './ArticlePurchaseDate';
import { ArticlePurchaseLocation } from './ArticlePurchaseLocation';
import { ArticleWarrantyApplicable } from './ArticleWarrantyApplicable';

export const ArticleWarranty = () => {
  const { article, view } = useArticleContext();

  return (
    <Stack gap="0.75rem">
      <ArticleWarrantyApplicable />
      {article.hasDistributorWarrantyExtension && <ArticleDistributorWarrantyExtension />}
      {view.warranty.fields.purchaseDate.shown && <ArticlePurchaseDate />}
      {view.warranty.fields.purchaseLocation.shown && <ArticlePurchaseLocation />}
      {view.warranty.fields.purchaseCountry.shown && <ArticlePurchaseCountry />}
      {view.warranty.fields.purchaseChannel.shown && <ArticlePurchaseChannel />}
      {view.warranty.fields.orderNumber.shown && <ArticleOrderNumber />}
      {view.warranty.fields.proofOfPurchase.shown && <ArticleProofOfPurchase />}
    </Stack>
  );
};
